import { Button, Card, Group, Stack, Text, ThemeIcon } from "@repo/ui/core";
import { IconExternalLink, IconPlayerPlay } from "@repo/ui/icons";
import { useCustomer } from "@contexts/CustomerContext";
import classes from "@styles/onsite.module.css";

export function DemoLauncher() {
  const customer = useCustomer();

  return (
    <Card
      padding="xl"
      radius="md"
      className={`${classes.demoCta} ${classes.glowGreen}`}
    >
      <Stack gap="md" align="center">
        <ThemeIcon
          size={56}
          radius="xl"
          variant="light"
          color="green"
        >
          <IconPlayerPlay size={28} />
        </ThemeIcon>
        <Text fw={600} size="lg">
          {customer.demoLabel}
        </Text>
        <Text size="sm" c="dimmed" ta="center">
          Opens the live platform environment in a new tab
        </Text>
        <Group>
          <Button
            component="a"
            href={customer.demoUrl}
            target="_blank"
            rel="noopener noreferrer"
            size="md"
            rightSection={<IconExternalLink size={16} />}
            style={{
              backgroundColor: "var(--customer-accent)",
            }}
          >
            Open Demo Environment
          </Button>
        </Group>
      </Stack>
    </Card>
  );
}
